export const paths: Record<
  string,
  {
    question: string;
    options?: { value: string; label: string; next?: string }[];
    freeText?: boolean;
    key?: string;
  }
> = {
  metier: {
    question: "Quel est votre métier ?",
    options: [
      { value: "Formateur", label: "Formateur", next: "targetAudience" },
      { value: "Responsable RH", label: "Responsable RH", next: "targetAudience" },
      { value: "Responsable HSE/QSE", label: "Responsable HSE/QSE", next: "targetAudience" },
      { value: "Manager", label: "Manager", next: "targetAudience" },
      { value: "Ingénieur pédagogique", label: "Ingénieur pédagogique", next: "targetAudience" },
      { value: "Développeur", label: "Développeur", next: "targetAudience" },
      { value: "Autre", label: "Autre", next: "targetAudience" },
    ],
  },
  targetAudience: {
    question: "Quel est le public cible de vos formations ?",
    freeText: true,
    key: "targetAudience",
  },
};
